export const cruiseTypes = /** @type {const} */ ([
  { label: 'Rivers', value: 'rivers' },
  { label: 'Oceans', value: 'oceans' },
  { label: 'Expeditions', value: 'expeditions' },
]);

const cruiseTypeLabelsByValue = Object.fromEntries(cruiseTypes.map(({ label, value }) => [value, label]));

/**
 * @param {string} value
 * @returns {string | null}
 */
export function getCruiseTypeLabel(value) {
  return cruiseTypeLabelsByValue[value] ?? null;
}
